<template>
    <div class="row justify-content-center">
        <div class="mt-3">
            <h1 class="display-3">Ошибка 404</h1>

        <h4 class="pt-3">Упс! Странца не найдена.</h4>
        <p class="text-muted">Возможно вы перешли по устаревшей ссылке.</p>
        <button class="btn btn-lg btn-blcok btn-primary" @click.prevent="goHome">Перейти на главную страницу</button>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'NotFoundComponent',
    components: {},
    data () {
      return {}
    },
    methods: {
      goHome () {
        this.$router.push({name: 'Home'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// 404.vue?5fe18bbb